/**
 *
 * Colors library
 *
 */

// Gray
export const salt10 = {
  light: "#FFFFFF",
  dark: "#0E0F11",
};

export const salt20 = {
  light: "#F1F5F8",
  dark: "#181B1E",
};

export const salt30 = {
  light: "#DDE5EE",
  dark: "#282D32",
};

export const salt40 = {
  light: "#BCC9D6",
  dark: "#32393F",
};

export const salt50 = {
  light: "#A0ADBA",
  dark: "#606C76",
};

export const salt60 = {
  light: "#606C76",
  dark: "#A0ADBA",
};

export const salt70 = {
  light: "#3A434A",
  dark: "#BCC9D6",
};

export const salt80 = {
  light: "#282D32",
  dark: "#DDE5EE",
};

export const salt90 = {
  light: "#181B1E",
  dark: "#F1F5F8",
};

export const salt100 = {
  light: "#0E0F11",
  dark: "#FFFFFF",
};


// SP Blue
export const spBlue5 = {
  light: "#EBF9FF",
  dark: "#1F2C33",
};

export const spBlue25 = {
  light: "#82DDFF",
  dark: "#136586",
};

export const spBlue50 = {
  light: "#00BFFF",
  dark: "#00BFFF",
};

export const spBlue75 = {
  light: "#004466",
  dark: "#BAE6F7",
};


// Parsley
export const parsley5 = {
  light: "#EBFFEB",
  dark: "#213123",
};

export const parsley25 = {
  light: "#93EC93",
  dark: "#136C22",
};

export const parsley50 = {
  light: "#00CC22",
  dark: "#06D028",
};

export const parsley75 = {
  light: "#008015",
  dark: "#A1F7B2",
};


// Macaroni
export const macaroni5 = {
  light: "#FFFAEB",
  dark: "#2F2C22",
};

export const macaroni25 = {
  light: "#FFDD80",
  dark: "#AD8C1F",
};

export const macaroni50 = {
  light: "#FFBB00",
  dark: "#FFC014",
};

export const macaroni75 = {
  light: "#826F21",
  dark: "#FFEE88",
};


// Melon
export const melon5 = {
  light: "#FFEEEB",
  dark: "#33211F",
};

export const melon25 = {
  light: "#FF8880",
  dark: "#6C1B13",
};

export const melon50 = {
  light: "#FF3929",
  dark: "#FF4433",
};

export const melon75 = {
  light: "#7E0B01",
  dark: "#FBBCB6",
};


// Apricot
export const apricot5 = {
  light: "#FFEFE0",
  dark: "#312721",
};

export const apricot25 = {
  light: "#FFBB80",
  dark: "#6C3713",
};

export const apricot50 = {
  light: "#FF6600",
  dark: "#FD750D",
};

export const apricot75 = {
  light: "#992900",
  dark: "#FDC8A5",
};


// Boba
export const boba5 = {
  light: "#F6F0E9",
  dark: "#312921",
};

export const boba25 = {
  light: "#D9BFA6",
  dark: "#594026",
};

export const boba50 = {
  light: "#B27F4C",
  dark: "#B27F4C",
};

export const boba75 = {
  light: "#664019",
  dark: "#ECD9C6",
};


// Matcha
export const matcha5 = {
  light: "#F6FFCC",
  dark: "#2E3121",
};

export const matcha25 = {
  light: "#E5FF80",
  dark: "#6A7A29",
};

export const matcha50 = {
  light: "#CCFF00",
  dark: "#C5E835",
};

export const matcha75 = {
  light: "#668000",
  dark: "#EBF9B3",
};


// Candy
export const candy5 = {
  light: "#DDEEFF",
  dark: "#1F2833",
};

export const candy25 = {
  light: "#80BBFF",
  dark: "#1F61AD",
};

export const candy50 = {
  light: "#0077FF",
  dark: "#0A7CFF",
};

export const candy75 = {
  light: "#033399",
  dark: "#99CCFF",
};


// Blueberry
export const blueberry5 = {
  light: "#EEEBFF",
  dark: "#232131",
};

export const blueberry25 = {
  light: "#9580FF",
  dark: "#4D3E98",
};

export const blueberry50 = {
  light: "#6647FF",
  dark: "#7257FA",
};

export const blueberry75 = {
  light: "#150080",
  dark: "#C2B6FB",
};


// Ube
export const ube5 = {
  light: "#FCEBFF",
  dark: "#2E2131",
};

export const ube25 = {
  light: "#EA80FF",
  dark: "#813D8F",
};

export const ube50 = {
  light: "#DD00FF",
  dark: "#DC3DF5",
};

export const ube75 = {
  light: "#550080",
  dark: "#F2B6FB",
};


// Dragon fruit
export const dragonfruit5 = {
  light: "#FFEBF3",
  dark: "#312127",
};

export const dragonfruit25 = {
  light: "#FF80BB",
  dark: "#A13668",
};

export const dragonfruit50 = {
  light: "#FF3388",
  dark: "#FF3D88",
};

export const dragonfruit75 = {
  light: "#800040",
  dark: "#FBB6D3",
};
